'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissBotTypingIndicator = undefined;

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _stopBotTyping = require('./stopBotTyping');

var dismissBotTypingIndicator = exports.dismissBotTypingIndicator = function dismissBotTypingIndicator(message) {
  return function (dispatch) {
    var threadId = (0, _pubnubMessageGetters.getThreadId)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _stopBotTyping.stopBotTyping)(threadId, senderId));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/dismissBotTypingIndicator.js
// module id = 423
// module chunks = 2 3